module.exports = __webpack_public_path__ + "img/features-bg_9.b9c6ebd0.png";